import React from 'react'
import database from '../../database.js'
import './style.css'
import {InstantSearch, Hits, Configure} from 'react-instantsearch/dom';
import { GoogleMap, Marker, withGoogleMap } from "react-google-maps";
import ReactMarkdown from 'react-markdown'


let RoughLocation = (props) => {
    return (<div className="alert alert-warning">Your rough location is being used.</div>);
  }
  

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            location: null
        }
    }

    componentDidMount() {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
              this.setState({
                location: position.coords.latitude+","+position.coords.longitude
              })
            //  appendLocation(location, 'fetched');
          }.bind(this));
        }
    }
    

    render() {
    var configure = (this.state.location)?
                      <Configure
                          aroundLatLng={this.state.location}
                          aroundRadius="all" /> :
                      <Configure
                          aroundLatLngViaIP={true}
                          aroundRadius="all" />;
    var alert = (!this.state.location)?<RoughLocation />:"";

    return (
      <div style={{"margin":"27px"}}>
        <Items />
        {alert}
        <span className="georesults">
          <InstantSearch
              appId="2TMQLT5H8U"
              apiKey="bdd7ad59e1017c678b25be971e33fe6f"
              indexName="refer">
              {configure}
              <Search />
            </InstantSearch>
        </span>
     </div>
    )
  }
}



class Items extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
          staticItems: null
        }
    }


    componentWillMount() {
        var docRef = database.collection("referLocations").where("static", "==", true);
    
        docRef.onSnapshot(function(querySnapshot) {
          let staticItems = {};
          console.log(querySnapshot)
            querySnapshot.forEach(function(doc) {
              staticItems[doc.id] = doc.data();
            });
          this.setState({
            staticItems: staticItems
          })
        }.bind(this));
    }

    render() {
        if(this.state.staticItems) {
          let staticDispayItems = [];
          for(var k in this.state.staticItems) {
            console.log( this.state.staticItems[k].website);
            if(this.state.staticItems[k].website === 'https://www.mind.org.uk/') {
                var item =  this.state.staticItems[k];
                var list =   <ul class="list-group">
                               <li class="list-group-item"><strong>Phone Number:</strong> {item.phoneNumber}</li>
                               <li class="list-group-item"><strong>Website:</strong> <a href={item.website}>{item.website}</a></li>
                             </ul>;
                staticDispayItems.push(<Panel title={k} list={list}><ReactMarkdown source={item.description}/></Panel>)
            }
          }
          return (
            <div>
              {staticDispayItems}
                {(staticDispayItems.length === 0)?"":<hr />}
            </div>
          );
        } else {
          return "";
        }
    
    }
}

class Panel extends React.Component {
    constructor(props) {
      super(props);
      this.props = props;
    }

    
    render() {
      return (
        <div class="panel panel-default"  >
          <div class="panel-heading" onClick={this.onTitleClick}>
            <h3 class="panel-title" >» {this.props.title}</h3>
          </div>
          <div class="panel-body">
            {this.props.children}
  
          </div>
          {this.props.list}
  
        </div>
      )
    }
  }


  
function SearchResult({hit}) {
    var list =   <ul class="list-group">
       <li class="list-group-item"><strong>Phone Number:</strong> {hit.phoneNumber}</li>
       <li class="list-group-item"><strong>Address:</strong> {hit.address}</li>
  
     </ul>;
  
    return (
      <Panel title={hit.objectID} list={list}>
        <MapComponent isMarkerShown
          position={hit._geoloc}
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: `200px` }} />}
          mapElement={<div style={{ height: `100%` }} />}></MapComponent>
      </Panel>
  
    );
  };
  
  
const MapComponent = withGoogleMap((props) =>
    <GoogleMap
      defaultZoom={16}
      defaultCenter={props.position}
    >
      {props.isMarkerShown && <Marker position={props.position} />}
    </GoogleMap>
);
  
  
class Search extends React.Component {
    constructor(props) {
      super(props);
      this.props = props;
      this.state = {
        query: ""
      }
    }
  
    render() {
      return (
        <Hits hitComponent={SearchResult} />
      )
    }
}
  


// WEBPACK FOOTER //
// ./src/components/Help/othersHelp.js